module.exports = __webpack_public_path__ + "img/merch_small.d207f8a4.jpg";